module.exports = __webpack_public_path__ + "static/media/Wesley Song.a8bd827f.png";